export const AccountErrors = {
    passwordInvalidError: 'password_invalid',
    passwordRequiredMessage: 'password_required',
    retypePasswordRequiredMessage: 'retype_password_required',
    currentPasswordRequiredMessage: 'current_password_required',
    newPasswordRequiredMessage: 'new_password_required',
    newPasswordValidMessage: 'new_password_invalid',
    invalidSignInErrorMessage: 'invalid_sign_in',
    accountLockedResetPasswordError: 'account_locked_reset_password',
    signInAccountUnrecognized: 'account_unrecognized',
    facebookAuthError: 'facebook_auth_error',
    signInAccountLocked4AttemptsError: 'account_locked_4_attempts',
    signInAccountLocked5AttemptsError: 'account_locked_5_attempts',
    signInAccountLocked6AttemptsError: 'account_locked_6_attempts',
    passwordStrengthFailedResetPasswordError: 'password_strength_failed_reset_password',
    emailRequiredMessage: 'email_required',
    emailValidMessage: 'email_invalid',
    emailAlreadyUsedMessage: 'email_already_used',
    sessionExpiredError: 'session_expired',
    forgotPasswordEmailNotFound: 'forgot_password_email_not_found',
    confirmPasswordValidationMessage: 'confirm_password_validation',
    resetPasswordAlreadyUsedMessage: 'reset_password_already_used',
    resetPasswordLinkExpiredError: 'reset_password_link_expired',
    resetPasswordLinkInvalidError: 'reset_password_link_invalid',
    passwordResetLimitExceeded: 'reset_password_limit_exceed',
    maintenanceError: 'maintenance_error',
    birthdayValidMessage: 'birthday_invalid',
    birthdayIsRequiredLabel: 'birthday_required',
    birthdayChangeError: 'birthday_change_error',
    newEmailDifferentMessage: 'new_email_different',
    newPasswordDifferentMessage: 'new_password_different',
    confirmEmailValidationMessage: 'confirm_email_invalid',
    emailAlreadyUsedErrorMessage: 'email_already_used',
    incorrectPassword: 'incorrect_password',
    addressRequiredMessage: 'address_required',
    addAddressInvalidErrorMessage: 'add_address_invalid',
    countryRequiredMessage: 'country_required',
    countryValidMessage: 'country_invalid',
    zipCodeRequiredMessage: 'zip_code_required',
    zipCodeValidMessage: 'zip_code_invalid',
    cityRequiredMessage: 'city_required',
    cityValidMessage: 'city_invalid',
    mobileNumberRequiredMessage: 'mobile_number_required',
    mobileNumberValidMessage: 'mobile_number_invalid',
    companyRequiredMessage: 'company_required',
    companyValidMessage: 'company_invalid',
    photoFormatNotSupported: 'photo_format_not_supported',
    photoSizeLimitExceeded: 'photo_size_limit_exceeded',
    genericPhotoUploadError: 'generic_photo_upload_error',
    preferredLanguageRequiredMessage: 'preferred_language_required',
    agreeRequiredMessage: 'agree_required',
    alreadyRegisteredMessage: 'already_registered'
};
